module.exports = __webpack_public_path__ + "img/up_full.2d932eba.png";